import React, { useState } from 'react';

function ReferralAnnouncement({ notices }: { notices: any }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!notices || notices.length === 0) {
    return null;
  }

  const currentNotice = notices[currentIndex];

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : notices.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < notices.length - 1 ? prev + 1 : 0));
  };

  return (
    <div className="mobile-view-referral-announcement-card">
      <div className="mobile-view-referral-announcement-content">
        <div className="mobile-view-referral-announcement-content-title">
          {currentNotice.title}
        </div>
        <div
          className="mobile-view-referral-announcement-content-text"
          dangerouslySetInnerHTML={{ __html: currentNotice.text }}
        />
      </div>

      {notices.length > 1 && (
        <div className="mobile-view-referral-announcement-navigation">
          <button
            className="mobile-view-referral-announcement-nav-button"
            onClick={handlePrevious}
            disabled={currentIndex === 0}
            style={{
              paddingBottom: '4px'
            }}
          >
            &#8249;
          </button>

          <button
            className="mobile-view-referral-announcement-nav-button"
            onClick={handleNext}
            disabled={currentIndex === notices.length - 1}
            style={{
              paddingBottom: '4px'
            }}
          >
            &#8250;
          </button>
        </div>
      )}
    </div>
  );
}
export default ReferralAnnouncement;
